import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/index.css';

// Define the custom theme with ALPHA's color palette
const theme = extendTheme({
  colors: {
    brand: {
      50: '#e6f2ff', // lightest blue
      100: '#b3d9ff',
      200: '#80bfff',
      300: '#4da6ff',
      400: '#1a8cff',
      500: '#0073e6', // primary blue
      600: '#0059b3',
      700: '#004080',
      800: '#00264d',
      900: '#000d1a', // darkest blue
    },
    green: {
      50: '#e6f7e6',
      100: '#c2e8c2',
      200: '#9dd99d',
      300: '#79ca79',
      400: '#55bb55',
      500: '#3ca63c', // primary green
      600: '#2e7d2e',
      700: '#1f531f',
      800: '#112a11',
      900: '#050f05',
    },
    earth: {
      50: '#f7f2e6',
      100: '#e8d9c2',
      200: '#d9c09d',
      300: '#caa679',
      400: '#bb8d55',
      500: '#a67b3c', // primary earth tone
      600: '#7d5c2e',
      700: '#533e1f',
      800: '#2a1f11',
      900: '#0f0a05',
    },
  },
  fonts: {
    heading: 'Poppins, sans-serif',
    body: 'Poppins, sans-serif',
  },
  styles: {
    global: {
      body: {
        bg: 'white',
        color: 'gray.800',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'bold',
        borderRadius: 'md',
      },
      variants: {
        primary: {
          bg: 'brand.500',
          color: 'white',
          _hover: {
            bg: 'brand.600',
          },
        },
        secondary: {
          bg: 'green.500',
          color: 'white',
          _hover: {
            bg: 'green.600',
          },
        },
        outline: {
          borderColor: 'brand.500',
          color: 'brand.500',
          _hover: {
            bg: 'brand.50',
          },
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ChakraProvider>
  </React.StrictMode>
);
